import { render, staticRenderFns } from "./v-zig-zag.vue?vue&type=template&id=612206e1&"
import script from "./v-zig-zag.vue?vue&type=script&lang=js&"
export * from "./v-zig-zag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports